import { z } from 'zod';

export const UpdateWorkingMemoryToolName = 'updateWorkingMemory' as const;

/**
 * Hard server-side cap on the stored note. Working memory is re-read on
 * every model call of every later turn, so an uncapped scratchpad would
 * grow into the most expensive part of the prompt.
 */
export const WORKING_MEMORY_MAX_CHARS = 4000;

/**
 * UpdateWorkingMemory tool contract. One markdown scratchpad per thread,
 * rewritten in full — the model curates it, the runtime only stores it.
 */
export const updateWorkingMemoryArgsSchema = z.object({
  memory: z
    .string()
    .describe(
      `Store arbitrary useful information and facts aquired during the conversation that should be persisted for future reference. The COMPLETE note to store, as short markdown lines (a few bullets, not prose). This REPLACES the previous note entirely — it is a full rewrite, not a patch, so anything you leave out is forgotten. Carry forward every line that is still true, drop the ones that are not. Keep it under ${WORKING_MEMORY_MAX_CHARS} characters. WHAT BELONGS: product or order ids under discussion, constraints the user gave (budget, dimensions, deadline, quantity), facts a tool could not confirm (e.g. "availability unknown for product 12345 — tool returned nothing"), open questions you still owe the user, and durable user preferences. WHAT DOES NOT: a transcript or recap of the conversation, anything already visible in the current turn, and anything you can look up again with a tool. Send an empty string to clear the note.`,
    ),
});

export const updateWorkingMemoryContentSchema = z.string();

export type UpdateWorkingMemoryArgs = z.infer<
  typeof updateWorkingMemoryArgsSchema
>;
export type UpdateWorkingMemoryContent = z.infer<
  typeof updateWorkingMemoryContentSchema
>;
